export default __webpack_public_path__ + "static/media/app_lexusplus.fa8b90ba.png";